import './StandardActionButton.scss'

type ComponentProps = {
  status:string
  id:string
  title:string
  onClick: (id:string, title:string) => void
}

const StandardActionButton = (props:ComponentProps) => {
  return (
    <div id = {props.id} className = {'standard-action-button ' + props.status} onClick = {() => {if (props.status==='enabled') props.onClick(props.id, props.title)}}>
      <div className='standard-action-button-title'>{props.title}</div>
    </div>
  )
}
export default StandardActionButton